module.exports = "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJwbGF5LXBhdXNlLnN2Zz8yMWRmYTMxNDliMjc0YWNiOWMxODE5ZDM0MmE2YTE2OSI7"


//////////////////
// WEBPACK FOOTER
// ./node_modules/blueimp-gallery/img/play-pause.svg
// module id = 527
// module chunks = 2